// extracted by mini-css-extract-plugin
module.exports = {"name":"BackInStockBody_name__6QsyH","subtitle":"BackInStockBody_subtitle__Tuomb","formWrapper":"BackInStockBody_formWrapper__8OqKd"};